<template>
  <v-card flat elevation="5">
    <div>
      <div class="donut-text text-center" :class="{ 'd-none': !dataExist }">
        <span>
          <CountTo
            :startVal="0"
            :endVal="tagPercentage"
            :duration="1500"
            :decimals="1"
            suffix="%"
          ></CountTo>
        </span>
      </div>
      <div class="tag-menu text-center">
        <v-card
          elevation="5"
          min-width="110"
          max-width="110"
          min-height="60"

          color="#DDDDDD"
        >
          <v-card-text class="card-text" id="menu_name">{{
            crowdTagMenu.name
          }}</v-card-text>

          <v-card-text class="card-text" id="menu_data"
            >人數: {{ crowdTagMenu.data }}</v-card-text>
        </v-card>
      </div>

      <v-lazy
        v-model="lazyActive"
        min-height="400"
        :options="{
          threshold: 0.1,
        }"
        transition="fade-transition"
      >
        <Charts :option="crowdTagReport" />
      </v-lazy>
    </div>
  </v-card>
</template>

<script>
import Charts from "@/components/Charts.vue";
import CountTo from "vue-count-to";

import { mapGetters, mapMutations } from "vuex";

var menu = {};

function setMenu() {
    document.getElementById("menu_name").innerHTML = menu.name;
    document.getElementById("menu_data").innerHTML = "人數: " + menu.data;
}

export default {
  components: {
    Charts,
    CountTo,
  },
  methods: {
    ...mapMutations("taganalysis", ["setCrowdTagReport", "setCrowdTagMenu"]),
  },

  computed: {
    ...mapGetters("taganalysis", ["getCrowdTag", "getCrowdTagMenu"]),

    crowdTagReport() {
      const option = this.reportData;
      const { data, subtitle } = this.getCrowdTag; //vuex
      option.series[0].data = data ? [...data] : [];

      option.subtitle.text = subtitle;
      return option;
    },
    tagPercentage() {
      this.setCrowdTagReport();
      return this.getCrowdTag.ratio;
    },

    //提示方框
    crowdTagMenu() {
      if (this.getCrowdTag.data.length != 0) {
      menu.name = this.getCrowdTag.data[0].name;
      menu.data = this.getCrowdTag.data[0].y;
      }

      if (document.getElementById("menu_name") != null) {
        setMenu();
      }
      this.setCrowdTagMenu(menu);

      return this.getCrowdTagMenu;
    },

    dataExist() {
      //vuex
      return this.getCrowdTag.data ? this.getCrowdTag.data.length > 0 : 0;
    },
  },
  data: () => ({
    lazyActive: false,
    // message: {},
    reportData: {
      chart: {
        type: "pie",
      },
      title: {
        text: "人群標籤佔比(%)",
        style: {
          fontFamily: "Roboto,sans-serif",
        },
      },
      subtitle: {
        text: "",
      },
      plotOptions: {
        dataLabels: {
          enabled: false,
        },

        pie: {
          //測試
          borderWidth: 0,
          cursor: "pointer",
          dataLabels: {
            enabled: false,
            curser: "pointer",
          },
        },
        series: {
          animation: {
            duration: 400,
          },

          point: {
            events: {
              mouseOver: function () {
                var series = this.series;
                var pIndex = this.index;

                menu.name = series.points[pIndex].name;
                menu.data = series.points[pIndex].y;
                setMenu();
              },
            },
          },
        },
        // pie: {
        //   dataLabels: {
        //     enabled: false,
        //   },
        // },
      },
      legend: {
        enabled: true,
      },
      series: [
        {
          name: "人數 ",
          innerSize: "70%",
          showInLegend: true,
          data: [],
          states: {
            hover: {
              enabled: false,
            },
            inactive: {
              opacity: 1,
            },
          },
        },
      ],
      credits: {
        enabled: false,
      },
      exporting: {
        relativeTo: "chart",
        buttons: {
          contextButton: {
            //改button樣式
            symbol: "download",
            menuItems: ["downloadCSV"],
          },
        },
      },
      helpIcon: {
        annotation:
          "進站人群中，選取標籤在帶有標籤人群中的比例，人群標籤佔比=選取標籤貼標人數/不重複貼標人數",
        enabled: true,
      },
    },
  }),
  props: {
    chartInfoState: Boolean,
  },
  watch: {
    chartInfoState() {
      if (this.chartInfoState === true) {
        let chartInfo = {
          data: this.reportData,
          id: "crowdTagPercent"
        };
        this.$emit("addChartInfo", chartInfo);
      }
    }
  },
};
</script>
<style lang="css" scoped>
.donut-text {
  position: absolute;
  z-index: 4;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -40%);
  font-size: 1.2rem;
  font-family: Arial, cursive, sans-serif !important;
}
.tag-menu {
  position: absolute;
  z-index: 4;
  top: 20%;
  left: 60%;

  transform: translate(50%, -40%);
  font-size: 0.5rem;
  font-weight: bold;
}
.card-text {
  padding: 6px;
  font-weight: bold;
  color: black;
}
</style>
